import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';
import { IConnectedApplicationSecretType } from '../types/ConnectedApplicationType';

// We don't actually support paging yet so the IGetItemsResult isnt really needed
export interface IGetConnectedApplicationsSecretResult extends IResult {
    connectedApplicationSecret: IConnectedApplicationSecretType;
}

function getConnectedApplicationsSecretRequestConfig(appId: string, secretId: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.14',
    httpMethod: 'GET',
    endpoint: 'connected-applications/' + appId + '/secrets/' + secretId,
    serverWideRequest: false
  };
}

export function callGetConnectedApplicationsSecret(appId: string, secretId: string) {
  return makeJsonRestApiRequest<void, IGetConnectedApplicationsSecretResult>({
    config: getConnectedApplicationsSecretRequestConfig(appId, secretId),
    request: null,
  });
}